import type { ModuleDependencyRow } from '../../masterdependency/framework';

type Props = { items?: ModuleDependencyRow[] };

export function ModuleDependencyPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.module} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <p className="text-sm font-medium">{item.module}</p>
            <span className="shrink-0 rounded-full bg-brand-50 px-2 py-0.5 text-xs font-medium text-brand-700 dark:bg-brand-950 dark:text-brand-300">
              {item.priority}
            </span>
          </div>
          <p className="mt-1 text-xs text-slate-500">Requires: {item.prerequisites}</p>
          <p className="text-xs text-slate-500">Used by: {item.dependents}</p>
          {item.blocking > 0 && <p className="mt-0.5 text-xs font-medium text-amber-600">{item.blocking} blocking</p>}
        </div>
      ))}
    </div>
  );
}
